import { HeadObject } from '@vueuse/head'
import {ContactPointI, SchemaTagOptionsI} from "@/Types/types";
import {Ajility, AjilityConstants} from "@/Enums/Ajility";

export const schemaTagOptions = (options: SchemaTagOptionsI): HeadObject => {
    const { title, description, robots } = options
    const url = options.url || window.location.href

    const image = window.location.origin + '/docuvault_logo.webp'
    const socialType = 'website'

    const contactPoints = AjilityConstants.ContactPoint.map((contact: ContactPointI) => ({
        "@type": contact.type,
        "telephone": contact.phone,
        "contactType": contact.contactType,
        "availableLanguage": contact.language
    }))

    const metaTags = [
        {
            name: 'description',
            content: description
        },
        {
            property: 'og:title',
            content: title
        },
        {
            property: 'og:description',
            content: description
        },
        {
            property: 'og:image',
            content: image
        },
        {
            property: 'og:url',
            content: url
        },
        {
            property: 'og:type',
            content: socialType
        },
        {
            name: 'twitter:card',
            content: 'summary_large_image'
        },
        {
            name: 'twitter:title',
            content: title
        },
        {
            name: 'twitter:description',
            content: description
        },
        {
            name: 'twitter:image',
            content: image
        }
    ]

    // Add robots tag dynamically if provided
    if (robots) {
        metaTags.push({
            name: 'robots',
            content: robots
        })
    }

    return {
        title,
        meta: metaTags,
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    "@context": "https://schema.org",
                    "@type": options.schemaType,
                    "name": title,
                    "url": url,
                    "logo": image,
                    "description": description,
                    "contactPoint": contactPoints,
                    "email": Ajility.ContactEmail,
                    "foundingDate": Ajility.FoundingDate,
                    "areaServed": AjilityConstants.AreaServed,
                    "sameAs": AjilityConstants.SocialLinks
                })
            }
        ]
    }
}
